import React from "react";
import { AllergiesContainer } from "../../Allergies/AllergiesContainer";

const PatientAllergiesContent = (): JSX.Element => <AllergiesContainer />;

export default PatientAllergiesContent;
